export default __webpack_public_path__ + "7874cf14495ac51854683557dbfa22b4.png";